
import { plantingZoneReducer } from "../reducer/PlantingZoneReducer";

export const reducer = plantingZoneReducer;